export default "__VITE_ASSET__HPcWyHav__"